<template>
    <f7-page name="ozon-a-ux-index" @page:init="onPageInit">
        <f7-navbar>
            <f7-nav-left>
                <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
            </f7-nav-left>
            <f7-nav-title sliding>Ozón a UV index</f7-nav-title>
            <f7-nav-right>
                <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
                <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
            </f7-nav-right>
        </f7-navbar>
        <template v-if="isDataLoaded">

            <f7-toolbar tabbar bottom>
                <f7-link tab-link="#ozon-tab-1" tab-link-active>Ozón</f7-link>
                <f7-link tab-link="#ozon-tab-2">UV index</f7-link>
            </f7-toolbar>
            <f7-tabs>
                <f7-tab id="ozon-tab-1" tab-active>
                    <f7-block strong class="no-margin">
                        <div class="text-align-center font-weight-bold text-uppercase">{{ ozonData.date_ts | moment('dddd - DD.MM.YYYY') }}</div>
                        <p>Priemerná hodnota celkového atmosférického ozónu nameraného na stanici Poprad-Gánovce je:</p>
                        <p class="text-align-center">
                            <strong class="text-color-blue">{{ ozonData.dobson }}</strong> Dobsonových jednotiek, čo je<br><strong class="text-color-blue">{{ ozonData.avg }}% {{ komentar }}</strong>.
                        </p>
                        <div v-if="ozonData.comment !== null"><strong>Dodatok:</strong> <p class="no-margin-top">{{ ozonData.comment }}</p></div>
                        <div v-if="ozonData.forecast !== null"><strong>Predpoveď na zajtra:</strong><p class="no-margin-top">{{ ozonData.forecast }}</p></div>
                    </f7-block>
                    <f7-block strong class="no-margin">
                        <div class="text-align-center font-weight-bold">
                            História ozónu
                        </div>
                        <div>
                            <highcharts ref="highcharts" :updateArgs="[true, true, true]" :options="chartOptions"></highcharts>
                        </div>
                    </f7-block>
                </f7-tab>
                <f7-tab id="ozon-tab-2">
                    <template v-if="uvIndexEnabled">
                        <f7-block strong class="no-margin">
                            <div class="font-weight-bold">Predpoveď UV indexu na poludnie</div>
                            <ul>
                                <li style="list-style:none" v-for="item in uvData.data" class="text-capitalize">{{ item.dt_ts | moment('dddd - DD.MM.YYYY')}}: <strong class="text-color-blue">{{ item.value }}</strong></li>
                            </ul>

                        </f7-block>

                        <f7-block strong class="no-margin">
                            <div class="font-weight-bold">Predpoveď UV indexu počas dňa</div>
                            <div v-for="item in uvData.images" class="text-capitalize text-align-center">
                                <div class="mt-1">{{ item.forecast_for_dt_ts | moment('dddd - DD.MM.YYYY')}}</div>
                                <pinch-zoom limitPan="true" disableZoomControl="disable" limitZoom="3">
                                    <img :src="item.url_image" class="img-fluid">
                                </pinch-zoom>
                            </div>
                        </f7-block>
                    </template>
                    <template v-else>
                        <f7-block strong class="text-align-center no-margin-top">
                            V období od 30. septembra do 15. marca a sa predpoveď slnečného UV indexu nevydáva
                        </f7-block>
                    </template>
                </f7-tab>

            </f7-tabs>



        </template>
    </f7-page>
</template>
<script>
    import Axios from "axios";
    import SHMUconf from "../js/SHMUconf";
    import PinchZoom from 'vue-pinch-zoom';
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts';

    import ozonChart from './old-ozon-chart-options'

    Highcharts.setOptions({
        lang: {
            weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
            shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
            months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
        },
        global: {
            useUTC: true
        }
    });

    export default {
        components: {
            'pinch-zoom': PinchZoom,
            highcharts: Chart
        },
        data: function () {
            return {
                ozonData: {},
                ozonHistoryData: [],
                uvData: {},
                isDataLoaded: false,
                lastUpdated: 0,
                tCheckInterval: null,
                chartOptions: ozonChart,
                data_dobson: [],
                data_dlhodoby: [],
                data_priemer: [],
                uvIndexEnabled: SHMUconf.ENABLE_UV_INDEX

            };
        },
        watch: {
            ozonHistoryData(v) {
                this.data_dobson = [];
                this.data_dlhodoby = [];
                this.data_priemer = [];
                v.forEach((item) => {
                    this.data_dobson.push([item.dt_ts * 1000, item.dobson]);
                    let dlhodoby_priemer = Math.round(item.dobson / (1 + (item.avg/100)));
                    this.data_dlhodoby.push([item.dt_ts * 1000, dlhodoby_priemer]);
                    this.data_priemer.push([item.dt_ts * 1000, item.avg]);
                })

                let m1 = this.chartOptions.series.find(item => (item.id) === 'm1');
                m1.data = this.data_dobson;
                let m2 = this.chartOptions.series.find(item => (item.id) === 'm2');
                m2.data = this.data_priemer;
                let m3 = this.chartOptions.series.find(item => (item.id) === 'm3');
                m3.data = this.data_dlhodoby;
            }

        },
        computed: {
            komentar: function() {
                if (parseInt(this.ozonData.avg) === 0) return 'na úrovni dlhodobého priemeru';
                else if (parseInt(this.ozonData.avg) < 0) return 'pod dlhodobým priemerom';
                else return 'nad dlhodobým priemerom';
            }
        },
        mounted() {
            const self = this;
            // otvorime hlavne menu
            this.$f7.accordion.close('.shmu-i-pocasie');
            this.$f7.accordion.open('.shmu-i-pocasie');


        },
        destroy() {
            clearInterval(this.tCheckInterval);
        },
        methods: {
            onPageInit() {
                this.pageReload(null, true);
            },
            updateChartData() {

                // https://codesandbox.io/s/7o37zv74rj

            },
            pageReload(event, isInit) {
                const self = this;

                if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

                    self.$f7.dialog.preloader('Načítavam...');

                    Axios.get(SHMUconf.API_BASE_URL + 'meteo/getozoneandindexdata', {
                        crossDomain: true,
                        cache: false,
                    })
                        .then((response) => {
                            if (!response.data.error) {
                                self.isDataLoaded = true;
                                self.ozonData = response.data.ozoneData;
                                self.ozonHistoryData = response.data.ozoneHistoryData;
                                self.uvData = response.data.uvData;
                                self.lastUpdated = self.$moment().unix();
                                // clearInterval(this.tCheckInterval);
                                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60*1000); // overujem kazdu minutu
                            } else {
                                self.$f7.dialog.alert('Nepodarilo sa načítať informácie o ozóne a UV indexe', 'Nastala chyba');
                            }

                            self.$f7.dialog.close();
                        }).catch((error) => {
                        self.$f7.dialog.close();
                        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
                    });

                }
            },
            checkLastUpdated() {
                if ((this.$moment().unix() - this.lastUpdated) > 30*60) { // ak posledne stiahnutie bolo pred vic ako 60 min, tak refresh
                    this.pageReload(null, false);
                }
            }

        }

    };
</script>

<style lang="scss">

    .img-fluid {
        max-width: 100%;
        height: auto;
    }

    .pinch-zoom-wrapper {
        background: var(--f7-color-white-rgb) !important;
    }

</style>
